var _defs, _path, _path2, _rect, _g, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnityDirectory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#c3954c;}.cls-3{fill:#fdfeff;}.cls-4{opacity:0.1;}.cls-5{fill:url(#radial-gradient);}.cls-6{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 12,
    y1: 4.54036,
    x2: 12,
    y2: 20.91935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfbc92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad9272"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -60.2,
    cy: 14.28571,
    r: 13.33242,
    gradientTransform: "translate(-0.5 -37.16667) rotate(-90) scale(0.83333 0.875)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 12,
    y1: 5.69422,
    x2: 12,
    y2: 24.05677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebdcb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4c6a7"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "folder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.5,19.25a.75083.75083,0,0,1-.75-.75V5.5a.75083.75083,0,0,1,.75-.75h6.293a.75531.75531,0,0,1,.53027.21973l.707.707A.25192.25192,0,0,0,12.207,5.75H19.5a.75083.75083,0,0,1,.75.75v12a.75083.75083,0,0,1-.75.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.79289,5a.5.5,0,0,1,.35356.14645l.7071.7071A.5.5,0,0,0,12.20711,6H19.5a.5.5,0,0,1,.5.5v12a.5.5,0,0,1-.5.5H4.5a.5.5,0,0,1-.5-.5V5.5A.5.5,0,0,1,4.5,5h6.29289m0-.5H4.5a1.00113,1.00113,0,0,0-1,1v13a1.00113,1.00113,0,0,0,1,1h15a1.00113,1.00113,0,0,0,1-1V6.5a1.00113,1.00113,0,0,0-1-1H12.20711L11.5,4.7929A.99348.99348,0,0,0,10.79289,4.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 5,
    y: 8,
    width: 14,
    height: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 5.25,
    y: 8.25,
    width: 13.5,
    height: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.5,8.5v9H5.5v-9h13M19,8H5V18H19V8Z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 3.75,
    y: 9.75,
    width: 16.5,
    height: 9.5,
    rx: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.5,10a.5.5,0,0,1,.5.5v8a.5.5,0,0,1-.5.5H4.5a.5.5,0,0,1-.5-.5v-8a.5.5,0,0,1,.5-.5h15m0-.5H4.5a1.00113,1.00113,0,0,0-1,1v8a1.00113,1.00113,0,0,0,1,1h15a1.00113,1.00113,0,0,0,1-1v-8a1.00113,1.00113,0,0,0-1-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityDirectory);
export default __webpack_public_path__ + "static/media/unity_directory.931b6ddafd39e2b07a1e77ee658508c5.svg";
export { ForwardRef as ReactComponent };